<form #legalInfoForm="ngForm" novalidate>
  <inline-msg [inlineMsg]="componentMessage"></inline-msg>
  <div class="col-12 text-center" *ngIf="refreshing">
    <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
  </div>

  <div class="form-group row">
    <div class="col-12 col-sm-12">
      <label for="fullLegalNameId">
        Full legal name
        <fa-icon [icon]="['far', 'check-circle']" *ngIf="legalInfoForm?.controls?.fullLegalName?.valid" class="validation-icon"></fa-icon>
        <fa-icon [icon]="['far', 'times-circle']" *ngIf="legalInfoForm?.controls?.fullLegalName?.errors?.required" class="validation-icon required"></fa-icon>
      </label>
      <input id="fullLegalNameId" required *ngIf ="legalInfo" type="text" trimText class="form-control" placeholder="Full legal name" name="fullLegalName" maxlength="100" [(ngModel)]="legalInfo.fullLegalName" i18n-placeholder="@@LEGAL-INFO-001"/>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-12 col-sm-12">
      <label for="legalInfoLine1Id" i18n="@@LEGAL-INFO-002">
        Address line 1
      </label>
      <input id="legalInfoLine1Id" *ngIf ="legalInfo?.legalAddress" type="text" trimText class="form-control" placeholder="Address line 1" name="legalInfoLine1" maxlength="100" [(ngModel)]="legalInfo.legalAddress.line1" i18n-placeholder="@@LEGAL-INFO-002"/>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-12 col-sm-12">
      <label for="legalInfoLine2Id" i18n="@@LEGAL-INFO-003">Address line 2</label>
      <input id="legalInfoLine2Id" *ngIf ="legalInfo?.legalAddress" type="text" trimText class="form-control" placeholder="Address line 2" name="legalInfoLine2" maxlength="100" [(ngModel)]="legalInfo.legalAddress.line2" i18n-placeholder="@@LEGAL-INFO-003"/>
    </div>
  </div>

  <notd-address [simple]="false"
                [showManualFields]="true"
                [address]="address"
                [allowLocator]="false"
                [countryRequired]="true"
                (countryEmitter)="countryEvent($event)">
  </notd-address>

  <div class="form-group row">
    <div *ngIf="address.countryCode !== 'US'" class="form-group col-12 col-sm-12 col-md-6 col-lg-6">
      <label for="regionId" i18n="@@LEGAL-INFO-004">Region</label>
      <input id="regionId" *ngIf ="legalInfo.legalAddress" type="text" trimText class="form-control" placeholder="Region" name="legalInfoRegion" maxlength="100" [(ngModel)]="legalInfo.legalAddress.region" i18n-placeholder="@@LEGAL-INFO-004"/>
    </div>
    <div *ngIf="address.countryCode === 'US'" class="form-group col-12 col-sm-12 col-md-6 col-lg-6">
      <label for="stateId" i18n="@@LEGAL-INFO-005">State</label>
      <notd-state-selector id="stateId" [defaultCountryCode] = "address?.countryCode" [defaultStateName] = "address?.region" (stateEmitter) = "stateEvent($event)"></notd-state-selector>
    </div>
    <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6">
      <label for="postalCodeId" i18n="@@LEGAL-INFO-006">Postal code</label>
      <input id="postalCodeId" *ngIf ="legalInfo.legalAddress" type="text" trimText class="form-control" placeholder="Postal code" name="legalInfoPostalCode" maxlength="50" [(ngModel)]="legalInfo.legalAddress.postalCode" i18n-placeholder="@@LEGAL-INFO-006"/>
    </div>
  </div>
  <inline-msg [inlineMsg] = "componentMessage"></inline-msg>
</form>

